module.exports = __webpack_public_path__ + "static/sound-65df9bdc31d437d160e12293eb585009.png";